import React, { useState, useEffect, useContext } from 'react';
import { VendorContext } from '../providers/Vendor.jsx';
import requests from '../utils/requests.js';
import { PersonContext } from '../providers/Person.jsx';
import Item from './editMenu/Item.jsx';
import StyledInput from '../common/StyledInput.jsx';
import Categories from './editMenu/Categories.jsx';
import Tags from './editMenu/TagBrowser.jsx';
import Items from './editMenu/Items.jsx';
import { s } from '../Style.jsx'

const EditMenu = () => {

    const { vendor, refreshVendor, refreshItems } = useContext(VendorContext);
    const { auth } = useContext(PersonContext);

    const [selectedTag, setSelectedTag] = useState(null);
    const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(null);
    const [selectedSubCategoryIndex, setSelectedSubCategoryIndex] = useState(null);

    const [editingVendor, setEditingVendor] = useState(vendor);
    useEffect(() => {
        setEditingVendor(vendor);
    }, [vendor]);

    const [editingItem, setEditingItem] = useState(null);
    const [editingCategory, setEditingCategoryState] = useState(null);
    const [editingSubCategory, setSelectedSubCategoryState] = useState(null);
    useEffect(() => {
        setEditingItem(vendor.items.find(i => i.id === editingItem?.id));
        setEditingCategoryState(selectedCategoryIndex !== null ? editingVendor.categories.find((category, i) => i === selectedCategoryIndex) : null);
        setSelectedSubCategoryState((selectedCategoryIndex !== null && selectedSubCategoryIndex !== null) ? (editingVendor.categories[selectedCategoryIndex]?.subCategories.find((subCategory, i) => i === selectedSubCategoryIndex) || null) : null);
    }, [selectedCategoryIndex, selectedSubCategoryIndex, editingVendor]);

    const setEditingCategory = (category, mod) => {
        setEditingVendor({ ...editingVendor, categories: editingVendor.categories.map((c, i) => i === selectedCategoryIndex ? category : c) });
        if (mod === "close") {
            setSelectedSubCategoryIndex(null);
        }
    };

    const setEditingSubCategory = (subCategory, mod) => {
        setEditingVendor({ ...editingVendor, categories: editingVendor.categories.map((c, i) => i === selectedCategoryIndex ? { ...c, subCategories: c.subCategories.map((s, j) => j === selectedSubCategoryIndex ? subCategory : s) } : c) });
        if (mod === "close") {
            setSelectedSubCategoryIndex(null);
        }
    };

    const view = () => {

        if (editingItem)
            return <Item item={vendor.items.find(i => i.id === editingItem.id)} editingItem={editingItem} setEditingItem={setEditingItem} />;

        if (selectedTag) return <>
            <s.H2><s.BackArrow does={() => setSelectedTag(null)} /> Edit {selectedTag}</s.H2>
            <Items addItem={() => requests.addItem(auth, { name: "New Item", tags: [selectedTag] }, vendor.id, () => refreshItems())} items={(vendor.items || []).filter(item => (item?.tags || []).includes(selectedTag))} setEditingItem={setEditingItem} editingItem={editingItem} />
        </>;

        if (selectedCategoryIndex === null) return <>
            <s.H2>Edit Store Menu</s.H2>
            <Categories selectedCategoryIndex={selectedCategoryIndex} categories={editingVendor?.categories} setCategories={e => setEditingVendor({ ...editingVendor, categories: e })} setSelectedCategoryIndex={setSelectedCategoryIndex} />
            <Tags selectedTag={selectedTag} setSelectedTag={setSelectedTag} tags={[...new Set((vendor.items || []).map(item => item.tags).flat().filter(t => t))]} />
        </>;

        if (editingCategory && selectedSubCategoryIndex === null) return <>
            <s.H2><s.BackArrow does={() => setSelectedCategoryIndex(null)} /> Edit Menu</s.H2>

            <div style={s.row}>
                <StyledInput placeholder="Name" value={editingCategory?.name} onChange={e => setEditingCategory({ ...editingCategory, name: e })} />
                <button style={s.button} onClick={() => setEditingCategory({ ...editingCategory, disabled: !editingCategory?.disabled })}>{!editingCategory?.disabled ? "Enabled" : "Disabled"}</button>
            </div>

            <div style={s.row}>
                <StyledInput placeholder="Tag" style={s.smallInput} value={editingCategory?.tag} onChange={e => setEditingCategory({ ...editingCategory, tag: e })} />
                <button style={s.button} onClick={() => setEditingVendor({ ...editingVendor, categories: editingVendor.categories.filter((c, i) => i !== selectedCategoryIndex) })}>Delete {editingCategory?.name}</button>
            </div>

            <div style={{ opacity: editingCategory?.disabled ? 0.5 : 1 }}>
                <Categories text={"Sub Menu"} selectedCategoryIndex={selectedSubCategoryIndex} categories={editingCategory?.subCategories} setCategories={e => setEditingCategory({ ...editingCategory, subCategories: e })} setSelectedCategoryIndex={setSelectedSubCategoryIndex} />
                {!editingCategory.tag
                    ? <p style={{ textAlign: "center", fontSize: 14 }}>Category must have a tag to add items.</p>
                    : <Items addItem={() => requests.addItem(auth, { name: "New Item", tags: [editingCategory.tag] }, vendor.id, () => refreshItems())} items={(vendor.items || []).filter(item => (item?.tags || []).includes(editingCategory.tag))} setEditingItem={setEditingItem} editingItem={editingItem} />
                }
            </div>
        </>;

        if (!!editingSubCategory) return <>
            <s.H2><s.BackArrow does={() => setSelectedSubCategoryIndex(null)} /> Edit Sub-Menu</s.H2>

            <div style={s.row}>
                <StyledInput placeholder="Name" value={editingSubCategory?.name} onChange={e => setEditingSubCategory({ ...editingSubCategory, name: e })} />
                <button style={s.button} onClick={() => setEditingSubCategory({ ...editingSubCategory, disabled: !editingSubCategory?.disabled })}>{!editingSubCategory?.disabled ? "Enabled" : "Disabled"}</button>
            </div>

            <div style={s.row}>
                <StyledInput placeholder="Tag" style={s.smallInput} value={editingSubCategory?.tag} onChange={e => setEditingSubCategory({ ...editingSubCategory, tag: e })} />
                <button style={s.button} onClick={() => setEditingCategory({ ...editingCategory, subCategories: editingCategory.subCategories.filter((c, i) => i !== selectedSubCategoryIndex) })}>Delete {editingSubCategory?.name}</button>
            </div>

            <div style={{ opacity: editingSubCategory?.disabled ? 0.5 : 1 }}>
                {!editingSubCategory.tag
                    ? <p style={{ textAlign: "center", fontSize: 14 }}>SubCategory must have a tag to add items.</p>
                    : <Items items={(vendor.items || []).filter(item => (item?.tags || []).includes(editingSubCategory.tag))} setEditingItem={setEditingItem} editingItem={editingItem} />
                }
            </div>
        </>;

    }

    return <div style={s.mobileContainer}>

        {view()}

        {!selectedTag && (JSON.stringify(editingVendor) !== JSON.stringify(vendor)) && <div style={s.pinned}>
            <button style={s.borderlessButton} onClick={() => setEditingVendor(vendor)}>Clear Changes</button>
            <button style={s.bigButton} onClick={() => requests.updateVendor(auth, editingVendor, vendor.id, refreshVendor)}>Save Changes</button>
        </div>}

    </div>;
}

export default EditMenu;